import script from "./AudioDeviceSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./AudioDeviceSettings.vue?vue&type=script&setup=true&lang=ts"

import "./AudioDeviceSettings.vue?vue&type=style&index=0&id=f2123ea0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f2123ea0"]])

export default __exports__